export default [
  { code: 'ACT', name: 'ACT' },
  { code: 'AET', name: 'AET' },
  { code: 'AGT', name: 'AGT' },
  { code: 'ART', name: 'ART' },
  { code: 'AST', name: 'AST' },
  { code: 'Africa/Abidjan', name: 'África/Abidjan' },
  { code: 'Africa/Accra', name: 'África/Accra' },
  { code: 'Africa/Addis_Ababa', name: 'África/Addis_Ababa' },
  { code: 'Africa/Algiers', name: 'África/Algiers' },
  { code: 'Africa/Asmara', name: 'África/Asmara' },
  { code: 'Africa/Asmera', name: 'África/Asmera' },
  { code: 'Africa/Bamako', name: 'África/Bamako' },
  { code: 'Africa/Bangui', name: 'África/Bangui' },
  { code: 'Africa/Banjul', name: 'África/Banjul' },
  { code: 'Africa/Bissau', name: 'África/Bissau' },
  { code: 'Africa/Blantyre', name: 'África/Blantyre' },
  { code: 'Africa/Brazzaville', name: 'África/Brazzaville' },
  { code: 'Africa/Bujumbura', name: 'África/Bujumbura' },
  { code: 'Africa/Cairo', name: 'África/Cairo' },
  { code: 'Africa/Casablanca', name: 'África/Casablanca' },
  { code: 'Africa/Ceuta', name: 'África/Ceuta' },
  { code: 'Africa/Conakry', name: 'África/Conakry' },
  { code: 'Africa/Dakar', name: 'África/Dakar' },
  { code: 'Africa/Dar_es_Salaam', name: 'África/Dar_es_Salaam' },
  { code: 'Africa/Djibouti', name: 'África/Djibouti' },
  { code: 'Africa/Douala', name: 'África/Douala' },
  { code: 'Africa/El_Aaiun', name: 'África/El_Aaiun' },
  { code: 'Africa/Freetown', name: 'África/Freetown' },
  { code: 'Africa/Gaborone', name: 'África/Gaborone' },
  { code: 'Africa/Harare', name: 'África/Harare' },
  { code: 'Africa/Johannesburg', name: 'África/Johannesburg' },
  { code: 'Africa/Juba', name: 'África/Juba' },
  { code: 'Africa/Kampala', name: 'África/Kampala' },
  { code: 'Africa/Khartoum', name: 'África/Khartoum' },
  { code: 'Africa/Kigali', name: 'África/Kigali' },
  { code: 'Africa/Kinshasa', name: 'África/Kinshasa' },
  { code: 'Africa/Lagos', name: 'África/Lagos' },
  { code: 'Africa/Libreville', name: 'África/Libreville' },
  { code: 'Africa/Lome', name: 'África/Lome' },
  { code: 'Africa/Luanda', name: 'África/Luanda' },
  { code: 'Africa/Lubumbashi', name: 'África/Lubumbashi' },
  { code: 'Africa/Lusaka', name: 'África/Lusaka' },
  { code: 'Africa/Malabo', name: 'África/Malabo' },
  { code: 'Africa/Maputo', name: 'África/Maputo' },
  { code: 'Africa/Maseru', name: 'África/Maseru' },
  { code: 'Africa/Mbabane', name: 'África/Mbabane' },
  { code: 'Africa/Mogadishu', name: 'África/Mogadishu' },
  { code: 'Africa/Monrovia', name: 'África/Monrovia' },
  { code: 'Africa/Nairobi', name: 'África/Nairobi' },
  { code: 'Africa/Ndjamena', name: 'África/Ndjamena' },
  { code: 'Africa/Niamey', name: 'África/Niamey' },
  { code: 'Africa/Nouakchott', name: 'África/Nouakchott' },
  { code: 'Africa/Ouagadougou', name: 'África/Ouagadougou' },
  { code: 'Africa/Porto-Novo', name: 'África/Porto-Novo' },
  { code: 'Africa/Sao_Tome', name: 'África/Sao_Tome' },
  { code: 'Africa/Timbuktu', name: 'África/Timbuktu' },
  { code: 'Africa/Tripoli', name: 'África/Tripoli' },
  { code: 'Africa/Tunis', name: 'África/Tunis' },
  { code: 'Africa/Windhoek', name: 'África/Windhoek' },
  { code: 'America/Adak', name: 'América/Adak' },
  { code: 'America/Anchorage', name: 'América/Anchorage' },
  { code: 'America/Anguilla', name: 'América/Anguilla' },
  { code: 'America/Antigua', name: 'América/Antigua' },
  { code: 'America/Araguaina', name: 'América/Araguaina' },
  {
    code: 'America/Argentina/Buenos_Aires',
    name: 'América/Argentina/Buenos_Aires',
  },
  { code: 'America/Argentina/Catamarca', name: 'América/Argentina/Catamarca' },
  {
    code: 'America/Argentina/ComodRivadavia',
    name: 'América/Argentina/ComodRivadavia',
  },
  { code: 'America/Argentina/Cordoba', name: 'América/Argentina/Cordoba' },
  { code: 'America/Argentina/Jujuy', name: 'América/Argentina/Jujuy' },
  { code: 'America/Argentina/La_Rioja', name: 'América/Argentina/La_Rioja' },
  { code: 'America/Argentina/Mendoza', name: 'América/Argentina/Mendoza' },
  {
    code: 'America/Argentina/Rio_Gallegos',
    name: 'América/Argentina/Rio_Gallegos',
  },
  { code: 'America/Argentina/Salta', name: 'América/Argentina/Salta' },
  { code: 'America/Argentina/San_Juan', name: 'América/Argentina/San_Juan' },
  { code: 'America/Argentina/San_Luis', name: 'América/Argentina/San_Luis' },
  { code: 'America/Argentina/Tucuman', name: 'América/Argentina/Tucuman' },
  { code: 'America/Argentina/Ushuaia', name: 'América/Argentina/Ushuaia' },
  { code: 'America/Aruba', name: 'América/Aruba' },
  { code: 'America/Asuncion', name: 'América/Asuncion' },
  { code: 'America/Atikokan', name: 'América/Atikokan' },
  { code: 'America/Atka', name: 'América/Atka' },
  { code: 'America/Bahia', name: 'América/Bahia' },
  { code: 'America/Bahia_Banderas', name: 'América/Bahia_Banderas' },
  { code: 'America/Barbados', name: 'América/Barbados' },
  { code: 'America/Belem', name: 'América/Belem' },
  { code: 'America/Belize', name: 'América/Belize' },
  { code: 'America/Blanc-Sablon', name: 'América/Blanc-Sablon' },
  { code: 'America/Boa_Vista', name: 'América/Boa_Vista' },
  { code: 'America/Bogota', name: 'América/Bogota' },
  { code: 'America/Boise', name: 'América/Boise' },
  { code: 'America/Buenos_Aires', name: 'América/Buenos_Aires' },
  { code: 'America/Cambridge_Bay', name: 'América/Cambridge_Bay' },
  { code: 'America/Campo_Grande', name: 'América/Campo_Grande' },
  { code: 'America/Cancun', name: 'América/Cancun' },
  { code: 'America/Caracas', name: 'América/Caracas' },
  { code: 'America/Catamarca', name: 'América/Catamarca' },
  { code: 'America/Cayenne', name: 'América/Cayenne' },
  { code: 'America/Cayman', name: 'América/Cayman' },
  { code: 'America/Chicago', name: 'América/Chicago' },
  { code: 'America/Chihuahua', name: 'América/Chihuahua' },
  { code: 'America/Coral_Harbour', name: 'América/Coral_Harbour' },
  { code: 'America/Cordoba', name: 'América/Cordoba' },
  { code: 'America/Costa_Rica', name: 'América/Costa_Rica' },
  { code: 'America/Creston', name: 'América/Creston' },
  { code: 'America/Cuiaba', name: 'América/Cuiaba' },
  { code: 'America/Curacao', name: 'América/Curacao' },
  { code: 'America/Danmarkshavn', name: 'América/Danmarkshavn' },
  { code: 'America/Dawson', name: 'América/Dawson' },
  { code: 'America/Dawson_Creek', name: 'América/Dawson_Creek' },
  { code: 'America/Denver', name: 'América/Denver' },
  { code: 'America/Detroit', name: 'América/Detroit' },
  { code: 'America/Dominica', name: 'América/Dominica' },
  { code: 'America/Edmonton', name: 'América/Edmonton' },
  { code: 'America/Eirunepe', name: 'América/Eirunepe' },
  { code: 'America/El_Salvador', name: 'América/El_Salvador' },
  { code: 'America/Ensenada', name: 'América/Ensenada' },
  { code: 'America/Fort_Wayne', name: 'América/Fort_Wayne' },
  { code: 'America/Fortaleza', name: 'América/Fortaleza' },
  { code: 'America/Glace_Bay', name: 'América/Glace_Bay' },
  { code: 'America/Godthab', name: 'América/Godthab' },
  { code: 'America/Goose_Bay', name: 'América/Goose_Bay' },
  { code: 'America/Grand_Turk', name: 'América/Grand_Turk' },
  { code: 'America/Grenada', name: 'América/Grenada' },
  { code: 'America/Guadeloupe', name: 'América/Guadeloupe' },
  { code: 'America/Guatemala', name: 'América/Guatemala' },
  { code: 'America/Guayaquil', name: 'América/Guayaquil' },
  { code: 'America/Guyana', name: 'América/Guyana' },
  { code: 'America/Halifax', name: 'América/Halifax' },
  { code: 'America/Havana', name: 'América/Havana' },
  { code: 'America/Hermosillo', name: 'América/Hermosillo' },
  {
    code: 'America/Indiana/Indianapolis',
    name: 'América/Indiana/Indianapolis',
  },
  { code: 'America/Indiana/Knox', name: 'América/Indiana/Knox' },
  { code: 'America/Indiana/Marengo', name: 'América/Indiana/Marengo' },
  { code: 'America/Indiana/Petersburg', name: 'América/Indiana/Petersburg' },
  { code: 'America/Indiana/Tell_City', name: 'América/Indiana/Tell_City' },
  { code: 'America/Indiana/Vevay', name: 'América/Indiana/Vevay' },
  { code: 'America/Indiana/Vincennes', name: 'América/Indiana/Vincennes' },
  { code: 'America/Indiana/Winamac', name: 'América/Indiana/Winamac' },
  { code: 'America/Indianapolis', name: 'América/Indianapolis' },
  { code: 'America/Inuvik', name: 'América/Inuvik' },
  { code: 'America/Iqaluit', name: 'América/Iqaluit' },
  { code: 'America/Jamaica', name: 'América/Jamaica' },
  { code: 'America/Jujuy', name: 'América/Jujuy' },
  { code: 'America/Juneau', name: 'América/Juneau' },
  { code: 'America/Kentucky/Louisville', name: 'América/Kentucky/Louisville' },
  { code: 'America/Kentucky/Monticello', name: 'América/Kentucky/Monticello' },
  { code: 'America/Knox_IN', name: 'América/Knox_IN' },
  { code: 'America/Kralendijk', name: 'América/Kralendijk' },
  { code: 'America/La_Paz', name: 'América/La_Paz' },
  { code: 'America/Lima', name: 'América/Lima' },
  { code: 'America/Los_Angeles', name: 'América/Los_Angeles' },
  { code: 'America/Louisville', name: 'América/Louisville' },
  { code: 'America/Lower_Princes', name: 'América/Lower_Princes' },
  { code: 'America/Maceio', name: 'América/Maceio' },
  { code: 'America/Managua', name: 'América/Managua' },
  { code: 'America/Manaus', name: 'América/Manaus' },
  { code: 'America/Marigot', name: 'América/Marigot' },
  { code: 'America/Martinique', name: 'América/Martinique' },
  { code: 'America/Matamoros', name: 'América/Matamoros' },
  { code: 'America/Mazatlan', name: 'América/Mazatlan' },
  { code: 'America/Mendoza', name: 'América/Mendoza' },
  { code: 'America/Menominee', name: 'América/Menominee' },
  { code: 'America/Merida', name: 'América/Merida' },
  { code: 'America/Metlakatla', name: 'América/Metlakatla' },
  { code: 'America/Mexico_City', name: 'América/Mexico_City' },
  { code: 'America/Miquelon', name: 'América/Miquelon' },
  { code: 'America/Moncton', name: 'América/Moncton' },
  { code: 'America/Monterrey', name: 'América/Monterrey' },
  { code: 'America/Montevideo', name: 'América/Montevideo' },
  { code: 'America/Montreal', name: 'América/Montreal' },
  { code: 'America/Montserrat', name: 'América/Montserrat' },
  { code: 'America/Nassau', name: 'América/Nassau' },
  { code: 'America/New_York', name: 'América/New_York' },
  { code: 'America/Nipigon', name: 'América/Nipigon' },
  { code: 'America/Nome', name: 'América/Nome' },
  { code: 'America/Noronha', name: 'América/Noronha' },
  { code: 'America/North_Dakota/Beulah', name: 'América/North_Dakota/Beulah' },
  { code: 'America/North_Dakota/Center', name: 'América/North_Dakota/Center' },
  {
    code: 'America/North_Dakota/New_Salem',
    name: 'América/North_Dakota/New_Salem',
  },
  { code: 'America/Ojinaga', name: 'América/Ojinaga' },
  { code: 'America/Panama', name: 'América/Panama' },
  { code: 'America/Pangnirtung', name: 'América/Pangnirtung' },
  { code: 'America/Paramaribo', name: 'América/Paramaribo' },
  { code: 'America/Phoenix', name: 'América/Phoenix' },
  { code: 'America/Port-au-Prince', name: 'América/Port-au-Prince' },
  { code: 'America/Port_of_Spain', name: 'América/Port_of_Spain' },
  { code: 'America/Porto_Acre', name: 'América/Porto_Acre' },
  { code: 'America/Porto_Velho', name: 'América/Porto_Velho' },
  { code: 'America/Puerto_Rico', name: 'América/Puerto_Rico' },
  { code: 'America/Rainy_River', name: 'América/Rainy_River' },
  { code: 'America/Rankin_Inlet', name: 'América/Rankin_Inlet' },
  { code: 'America/Recife', name: 'América/Recife' },
  { code: 'America/Regina', name: 'América/Regina' },
  { code: 'America/Resolute', name: 'América/Resolute' },
  { code: 'America/Rio_Branco', name: 'América/Rio_Branco' },
  { code: 'America/Rosario', name: 'América/Rosario' },
  { code: 'America/Santa_Isabel', name: 'América/Santa_Isabel' },
  { code: 'America/Santarem', name: 'América/Santarem' },
  { code: 'America/Santiago', name: 'América/Santiago' },
  { code: 'America/Santo_Domingo', name: 'América/Santo_Domingo' },
  { code: 'America/Sao_Paulo', name: 'América/Sao_Paulo' },
  { code: 'America/Scoresbysund', name: 'América/Scoresbysund' },
  { code: 'America/Shiprock', name: 'América/Shiprock' },
  { code: 'America/Sitka', name: 'América/Sitka' },
  { code: 'America/St_Barthelemy', name: 'América/St_Barthelemy' },
  { code: 'America/St_Johns', name: 'América/St_Johns' },
  { code: 'America/St_Kitts', name: 'América/St_Kitts' },
  { code: 'America/St_Lucia', name: 'América/St_Lucia' },
  { code: 'America/St_Thomas', name: 'América/St_Thomas' },
  { code: 'America/St_Vincent', name: 'América/St_Vincent' },
  { code: 'America/Swift_Current', name: 'América/Swift_Current' },
  { code: 'America/Tegucigalpa', name: 'América/Tegucigalpa' },
  { code: 'America/Thule', name: 'América/Thule' },
  { code: 'America/Thunder_Bay', name: 'América/Thunder_Bay' },
  { code: 'America/Tijuana', name: 'América/Tijuana' },
  { code: 'America/Toronto', name: 'América/Toronto' },
  { code: 'America/Tortola', name: 'América/Tortola' },
  { code: 'America/Vancouver', name: 'América/Vancouver' },
  { code: 'America/Virgin', name: 'América/Virgin' },
  { code: 'America/Whitehorse', name: 'América/Whitehorse' },
  { code: 'America/Winnipeg', name: 'América/Winnipeg' },
  { code: 'America/Yakutat', name: 'América/Yakutat' },
  { code: 'America/Yellowknife', name: 'América/Yellowknife' },
  { code: 'Antarctica/Casey', name: 'Antarctica/Casey' },
  { code: 'Antarctica/Davis', name: 'Antarctica/Davis' },
  { code: 'Antarctica/DumontDUrville', name: 'Antarctica/DumontDUrville' },
  { code: 'Antarctica/Macquarie', name: 'Antarctica/Macquarie' },
  { code: 'Antarctica/Mawson', name: 'Antarctica/Mawson' },
  { code: 'Antarctica/McMurdo', name: 'Antarctica/McMurdo' },
  { code: 'Antarctica/Palmer', name: 'Antarctica/Palmer' },
  { code: 'Antarctica/Rothera', name: 'Antarctica/Rothera' },
  { code: 'Antarctica/South_Pole', name: 'Antarctica/South_Pole' },
  { code: 'Antarctica/Syowa', name: 'Antarctica/Syowa' },
  { code: 'Antarctica/Troll', name: 'Antarctica/Troll' },
  { code: 'Antarctica/Vostok', name: 'Antarctica/Vostok' },
  { code: 'Arctic/Longyearbyen', name: 'Arctic/Longyearbyen' },
  { code: 'Asia/Aden', name: 'Asia/Aden' },
  { code: 'Asia/Almaty', name: 'Asia/Almaty' },
  { code: 'Asia/Amman', name: 'Asia/Amman' },
  { code: 'Asia/Anadyr', name: 'Asia/Anadyr' },
  { code: 'Asia/Aqtau', name: 'Asia/Aqtau' },
  { code: 'Asia/Aqtobe', name: 'Asia/Aqtobe' },
  { code: 'Asia/Ashgabat', name: 'Asia/Ashgabat' },
  { code: 'Asia/Ashkhabad', name: 'Asia/Ashkhabad' },
  { code: 'Asia/Baghdad', name: 'Asia/Baghdad' },
  { code: 'Asia/Bahrain', name: 'Asia/Bahrain' },
  { code: 'Asia/Baku', name: 'Asia/Baku' },
  { code: 'Asia/Bangkok', name: 'Asia/Bangkok' },
  { code: 'Asia/Beirut', name: 'Asia/Beirut' },
  { code: 'Asia/Bishkek', name: 'Asia/Bishkek' },
  { code: 'Asia/Brunei', name: 'Asia/Brunei' },
  { code: 'Asia/Calcutta', name: 'Asia/Calcutta' },
  { code: 'Asia/Chita', name: 'Asia/Chita' },
  { code: 'Asia/Choibalsan', name: 'Asia/Choibalsan' },
  { code: 'Asia/Chongqing', name: 'Asia/Chongqing' },
  { code: 'Asia/Chungking', name: 'Asia/Chungking' },
  { code: 'Asia/Colombo', name: 'Asia/Colombo' },
  { code: 'Asia/Dacca', name: 'Asia/Dacca' },
  { code: 'Asia/Damascus', name: 'Asia/Damascus' },
  { code: 'Asia/Dhaka', name: 'Asia/Dhaka' },
  { code: 'Asia/Dili', name: 'Asia/Dili' },
  { code: 'Asia/Dubai', name: 'Asia/Dubai' },
  { code: 'Asia/Dushanbe', name: 'Asia/Dushanbe' },
  { code: 'Asia/Gaza', name: 'Asia/Gaza' },
  { code: 'Asia/Harbin', name: 'Asia/Harbin' },
  { code: 'Asia/Hebron', name: 'Asia/Hebron' },
  { code: 'Asia/Ho_Chi_Minh', name: 'Asia/Ho_Chi_Minh' },
  { code: 'Asia/Hong_Kong', name: 'Asia/Hong_Kong' },
  { code: 'Asia/Hovd', name: 'Asia/Hovd' },
  { code: 'Asia/Irkutsk', name: 'Asia/Irkutsk' },
  { code: 'Asia/Istanbul', name: 'Asia/Istanbul' },
  { code: 'Asia/Jakarta', name: 'Asia/Jakarta' },
  { code: 'Asia/Jayapura', name: 'Asia/Jayapura' },
  { code: 'Asia/Jerusalem', name: 'Asia/Jerusalem' },
  { code: 'Asia/Kabul', name: 'Asia/Kabul' },
  { code: 'Asia/Kamchatka', name: 'Asia/Kamchatka' },
  { code: 'Asia/Karachi', name: 'Asia/Karachi' },
  { code: 'Asia/Kashgar', name: 'Asia/Kashgar' },
  { code: 'Asia/Kathmandu', name: 'Asia/Kathmandu' },
  { code: 'Asia/Katmandu', name: 'Asia/Katmandu' },
  { code: 'Asia/Khandyga', name: 'Asia/Khandyga' },
  { code: 'Asia/Kolkata', name: 'Asia/Kolkata' },
  { code: 'Asia/Krasnoyarsk', name: 'Asia/Krasnoyarsk' },
  { code: 'Asia/Kuala_Lumpur', name: 'Asia/Kuala_Lumpur' },
  { code: 'Asia/Kuching', name: 'Asia/Kuching' },
  { code: 'Asia/Kuwait', name: 'Asia/Kuwait' },
  { code: 'Asia/Macao', name: 'Asia/Macao' },
  { code: 'Asia/Macau', name: 'Asia/Macau' },
  { code: 'Asia/Magadan', name: 'Asia/Magadan' },
  { code: 'Asia/Makassar', name: 'Asia/Makassar' },
  { code: 'Asia/Manila', name: 'Asia/Manila' },
  { code: 'Asia/Muscat', name: 'Asia/Muscat' },
  { code: 'Asia/Nicosia', name: 'Asia/Nicosia' },
  { code: 'Asia/Novokuznetsk', name: 'Asia/Novokuznetsk' },
  { code: 'Asia/Novosibirsk', name: 'Asia/Novosibirsk' },
  { code: 'Asia/Omsk', name: 'Asia/Omsk' },
  { code: 'Asia/Oral', name: 'Asia/Oral' },
  { code: 'Asia/Phnom_Penh', name: 'Asia/Phnom_Penh' },
  { code: 'Asia/Pontianak', name: 'Asia/Pontianak' },
  { code: 'Asia/Pyongyang', name: 'Asia/Pyongyang' },
  { code: 'Asia/Qatar', name: 'Asia/Qatar' },
  { code: 'Asia/Qyzylorda', name: 'Asia/Qyzylorda' },
  { code: 'Asia/Rangoon', name: 'Asia/Rangoon' },
  { code: 'Asia/Riyadh', name: 'Asia/Riyadh' },
  { code: 'Asia/Riyadh87', name: 'Asia/Riyadh87' },
  { code: 'Asia/Riyadh88', name: 'Asia/Riyadh88' },
  { code: 'Asia/Riyadh89', name: 'Asia/Riyadh89' },
  { code: 'Asia/Saigon', name: 'Asia/Saigon' },
  { code: 'Asia/Sakhalin', name: 'Asia/Sakhalin' },
  { code: 'Asia/Samarkand', name: 'Asia/Samarkand' },
  { code: 'Asia/Seoul', name: 'Asia/Seoul' },
  { code: 'Asia/Shanghai', name: 'Asia/Shanghai' },
  { code: 'Asia/Singapore', name: 'Asia/Singapore' },
  { code: 'Asia/Srednekolymsk', name: 'Asia/Srednekolymsk' },
  { code: 'Asia/Taipei', name: 'Asia/Taipei' },
  { code: 'Asia/Tashkent', name: 'Asia/Tashkent' },
  { code: 'Asia/Tbilisi', name: 'Asia/Tbilisi' },
  { code: 'Asia/Tehran', name: 'Asia/Tehran' },
  { code: 'Asia/Tel_Aviv', name: 'Asia/Tel_Aviv' },
  { code: 'Asia/Thimbu', name: 'Asia/Thimbu' },
  { code: 'Asia/Thimphu', name: 'Asia/Thimphu' },
  { code: 'Asia/Tokyo', name: 'Asia/Tokyo' },
  { code: 'Asia/Ujung_Pandang', name: 'Asia/Ujung_Pandang' },
  { code: 'Asia/Ulaanbaatar', name: 'Asia/Ulaanbaatar' },
  { code: 'Asia/Ulan_Bator', name: 'Asia/Ulan_Bator' },
  { code: 'Asia/Urumqi', name: 'Asia/Urumqi' },
  { code: 'Asia/Ust-Nera', name: 'Asia/Ust-Nera' },
  { code: 'Asia/Vientiane', name: 'Asia/Vientiane' },
  { code: 'Asia/Vladivostok', name: 'Asia/Vladivostok' },
  { code: 'Asia/Yakutsk', name: 'Asia/Yakutsk' },
  { code: 'Asia/Yekaterinburg', name: 'Asia/Yekaterinburg' },
  { code: 'Asia/Yerevan', name: 'Asia/Yerevan' },
  { code: 'Atlantic/Azores', name: 'Atlantic/Azores' },
  { code: 'Atlantic/Bermuda', name: 'Atlantic/Bermuda' },
  { code: 'Atlantic/Canary', name: 'Atlantic/Canary' },
  { code: 'Atlantic/Cape_Verde', name: 'Atlantic/Cape_Verde' },
  { code: 'Atlantic/Faeroe', name: 'Atlantic/Faeroe' },
  { code: 'Atlantic/Faroe', name: 'Atlantic/Faroe' },
  { code: 'Atlantic/Jan_Mayen', name: 'Atlantic/Jan_Mayen' },
  { code: 'Atlantic/Madeira', name: 'Atlantic/Madeira' },
  { code: 'Atlantic/Reykjavik', name: 'Atlantic/Reykjavik' },
  { code: 'Atlantic/South_Georgia', name: 'Atlantic/South_Georgia' },
  { code: 'Atlantic/St_Helena', name: 'Atlantic/St_Helena' },
  { code: 'Atlantic/Stanley', name: 'Atlantic/Stanley' },
  { code: 'Australia/ACT', name: 'Australia/ACT' },
  { code: 'Australia/Adelaide', name: 'Australia/Adelaide' },
  { code: 'Australia/Brisbane', name: 'Australia/Brisbane' },
  { code: 'Australia/Broken_Hill', name: 'Australia/Broken_Hill' },
  { code: 'Australia/Canberra', name: 'Australia/Canberra' },
  { code: 'Australia/Currie', name: 'Australia/Currie' },
  { code: 'Australia/Darwin', name: 'Australia/Darwin' },
  { code: 'Australia/Eucla', name: 'Australia/Eucla' },
  { code: 'Australia/Hobart', name: 'Australia/Hobart' },
  { code: 'Australia/LHI', name: 'Australia/LHI' },
  { code: 'Australia/Lindeman', name: 'Australia/Lindeman' },
  { code: 'Australia/Lord_Howe', name: 'Australia/Lord_Howe' },
  { code: 'Australia/Melbourne', name: 'Australia/Melbourne' },
  { code: 'Australia/NSW', name: 'Australia/NSW' },
  { code: 'Australia/North', name: 'Australia/North' },
  { code: 'Australia/Perth', name: 'Australia/Perth' },
  { code: 'Australia/Queensland', name: 'Australia/Queensland' },
  { code: 'Australia/South', name: 'Australia/South' },
  { code: 'Australia/Sydney', name: 'Australia/Sydney' },
  { code: 'Australia/Tasmania', name: 'Australia/Tasmania' },
  { code: 'Australia/Victoria', name: 'Australia/Victoria' },
  { code: 'Australia/West', name: 'Australia/West' },
  { code: 'Australia/Yancowinna', name: 'Australia/Yancowinna' },
  { code: 'BET', name: 'BET' },
  { code: 'BST', name: 'BST' },
  { code: 'Brazil/Acre', name: 'Brazil/Acre' },
  { code: 'Brazil/DeNoronha', name: 'Brazil/DeNoronha' },
  { code: 'Brazil/East', name: 'Brazil/East' },
  { code: 'Brazil/West', name: 'Brazil/West' },
  { code: 'CAT', name: 'CAT' },
  { code: 'CET', name: 'CET' },
  { code: 'CNT', name: 'CNT' },
  { code: 'CST', name: 'CST' },
  { code: 'CST6CDT', name: 'CST6CDT' },
  { code: 'CTT', name: 'CTT' },
  { code: 'Canada/Atlantic', name: 'Canada/Atlantic' },
  { code: 'Canada/Central', name: 'Canada/Central' },
  { code: 'Canada/East-Saskatchewan', name: 'Canada/East-Saskatchewan' },
  { code: 'Canada/Eastern', name: 'Canada/Eastern' },
  { code: 'Canada/Mountain', name: 'Canada/Mountain' },
  { code: 'Canada/Newfoundland', name: 'Canada/Newfoundland' },
  { code: 'Canada/Pacific', name: 'Canada/Pacific' },
  { code: 'Canada/Saskatchewan', name: 'Canada/Saskatchewan' },
  { code: 'Canada/Yukon', name: 'Canada/Yukon' },
  { code: 'Chile/Continental', name: 'Chile/Continental' },
  { code: 'Chile/EasterIsland', name: 'Chile/EasterIsland' },
  { code: 'Cuba', name: 'Cuba' },
  { code: 'EAT', name: 'EAT' },
  { code: 'ECT', name: 'ECT' },
  { code: 'EET', name: 'EET' },
  { code: 'EST', name: 'EST' },
  { code: 'EST5EDT', name: 'EST5EDT' },
  { code: 'Egypt', name: 'Egypt' },
  { code: 'Eire', name: 'Eire' },
  { code: 'Etc/GMT', name: 'Etc/GMT' },
  { code: 'Etc/GMT+0', name: 'Etc/GMT+0' },
  { code: 'Etc/GMT+1', name: 'Etc/GMT+1' },
  { code: 'Etc/GMT+10', name: 'Etc/GMT+10' },
  { code: 'Etc/GMT+11', name: 'Etc/GMT+11' },
  { code: 'Etc/GMT+12', name: 'Etc/GMT+12' },
  { code: 'Etc/GMT+2', name: 'Etc/GMT+2' },
  { code: 'Etc/GMT+3', name: 'Etc/GMT+3' },
  { code: 'Etc/GMT+4', name: 'Etc/GMT+4' },
  { code: 'Etc/GMT+5', name: 'Etc/GMT+5' },
  { code: 'Etc/GMT+6', name: 'Etc/GMT+6' },
  { code: 'Etc/GMT+7', name: 'Etc/GMT+7' },
  { code: 'Etc/GMT+8', name: 'Etc/GMT+8' },
  { code: 'Etc/GMT+9', name: 'Etc/GMT+9' },
  { code: 'Etc/GMT-0', name: 'Etc/GMT-0' },
  { code: 'Etc/GMT-1', name: 'Etc/GMT-1' },
  { code: 'Etc/GMT-10', name: 'Etc/GMT-10' },
  { code: 'Etc/GMT-11', name: 'Etc/GMT-11' },
  { code: 'Etc/GMT-12', name: 'Etc/GMT-12' },
  { code: 'Etc/GMT-13', name: 'Etc/GMT-13' },
  { code: 'Etc/GMT-14', name: 'Etc/GMT-14' },
  { code: 'Etc/GMT-2', name: 'Etc/GMT-2' },
  { code: 'Etc/GMT-3', name: 'Etc/GMT-3' },
  { code: 'Etc/GMT-4', name: 'Etc/GMT-4' },
  { code: 'Etc/GMT-5', name: 'Etc/GMT-5' },
  { code: 'Etc/GMT-6', name: 'Etc/GMT-6' },
  { code: 'Etc/GMT-7', name: 'Etc/GMT-7' },
  { code: 'Etc/GMT-8', name: 'Etc/GMT-8' },
  { code: 'Etc/GMT-9', name: 'Etc/GMT-9' },
  { code: 'Etc/GMT0', name: 'Etc/GMT0' },
  { code: 'Etc/Greenwich', name: 'Etc/Greenwich' },
  { code: 'Etc/UCT', name: 'Etc/UCT' },
  { code: 'Etc/UTC', name: 'Etc/UTC' },
  { code: 'Etc/Universal', name: 'Etc/Universal' },
  { code: 'Etc/Zulu', name: 'Etc/Zulu' },
  { code: 'Europe/Amsterdam', name: 'Europa/Amsterdam' },
  { code: 'Europe/Andorra', name: 'Europa/Andorra' },
  { code: 'Europe/Athens', name: 'Europa/Athens' },
  { code: 'Europe/Belfast', name: 'Europa/Belfast' },
  { code: 'Europe/Belgrade', name: 'Europa/Belgrade' },
  { code: 'Europe/Berlin', name: 'Europa/Berlin' },
  { code: 'Europe/Bratislava', name: 'Europa/Bratislava' },
  { code: 'Europe/Brussels', name: 'Europa/Brussels' },
  { code: 'Europe/Bucharest', name: 'Europa/Bucharest' },
  { code: 'Europe/Budapest', name: 'Europa/Budapest' },
  { code: 'Europe/Busingen', name: 'Europa/Busingen' },
  { code: 'Europe/Chisinau', name: 'Europa/Chisinau' },
  { code: 'Europe/Copenhagen', name: 'Europa/Copenhagen' },
  { code: 'Europe/Dublin', name: 'Europa/Dublin' },
  { code: 'Europe/Gibraltar', name: 'Europa/Gibraltar' },
  { code: 'Europe/Guernsey', name: 'Europa/Guernsey' },
  { code: 'Europe/Helsinki', name: 'Europa/Helsinki' },
  { code: 'Europe/Isle_of_Man', name: 'Europa/Isle_of_Man' },
  { code: 'Europe/Istanbul', name: 'Europa/Istanbul' },
  { code: 'Europe/Jersey', name: 'Europa/Jersey' },
  { code: 'Europe/Kaliningrad', name: 'Europa/Kaliningrad' },
  { code: 'Europe/Kiev', name: 'Europa/Kiev' },
  { code: 'Europe/Lisbon', name: 'Europa/Lisbon' },
  { code: 'Europe/Ljubljana', name: 'Europa/Ljubljana' },
  { code: 'Europe/London', name: 'Europa/London' },
  { code: 'Europe/Luxembourg', name: 'Europa/Luxembourg' },
  { code: 'Europe/Madrid', name: 'Europa/Madrid' },
  { code: 'Europe/Malta', name: 'Europa/Malta' },
  { code: 'Europe/Mariehamn', name: 'Europa/Mariehamn' },
  { code: 'Europe/Minsk', name: 'Europa/Minsk' },
  { code: 'Europe/Monaco', name: 'Europa/Monaco' },
  { code: 'Europe/Moscow', name: 'Europa/Moscow' },
  { code: 'Europe/Nicosia', name: 'Europa/Nicosia' },
  { code: 'Europe/Oslo', name: 'Europa/Oslo' },
  { code: 'Europe/Paris', name: 'Europa/Paris' },
  { code: 'Europe/Podgorica', name: 'Europa/Podgorica' },
  { code: 'Europe/Prague', name: 'Europa/Prague' },
  { code: 'Europe/Riga', name: 'Europa/Riga' },
  { code: 'Europe/Rome', name: 'Europa/Rome' },
  { code: 'Europe/Samara', name: 'Europa/Samara' },
  { code: 'Europe/San_Marino', name: 'Europa/San_Marino' },
  { code: 'Europe/Sarajevo', name: 'Europa/Sarajevo' },
  { code: 'Europe/Simferopol', name: 'Europa/Simferopol' },
  { code: 'Europe/Skopje', name: 'Europa/Skopje' },
  { code: 'Europe/Sofia', name: 'Europa/Sofia' },
  { code: 'Europe/Stockholm', name: 'Europa/Stockholm' },
  { code: 'Europe/Tallinn', name: 'Europa/Tallinn' },
  { code: 'Europe/Tirane', name: 'Europa/Tirane' },
  { code: 'Europe/Tiraspol', name: 'Europa/Tiraspol' },
  { code: 'Europe/Uzhgorod', name: 'Europa/Uzhgorod' },
  { code: 'Europe/Vaduz', name: 'Europa/Vaduz' },
  { code: 'Europe/Vatican', name: 'Europa/Vatican' },
  { code: 'Europe/Vienna', name: 'Europa/Vienna' },
  { code: 'Europe/Vilnius', name: 'Europa/Vilnius' },
  { code: 'Europe/Volgograd', name: 'Europa/Volgograd' },
  { code: 'Europe/Warsaw', name: 'Europa/Warsaw' },
  { code: 'Europe/Zagreb', name: 'Europa/Zagreb' },
  { code: 'Europe/Zaporozhye', name: 'Europa/Zaporozhye' },
  { code: 'Europe/Zurich', name: 'Europa/Zurich' },
  { code: 'GB', name: 'GB' },
  { code: 'GB-Eire', name: 'GB-Eire' },
  { code: 'GMT', name: 'GMT' },
  { code: 'GMT0', name: 'GMT0' },
  { code: 'Greenwich', name: 'Greenwich' },
  { code: 'HST', name: 'HST' },
  { code: 'Hongkong', name: 'Hongkong' },
  { code: 'IET', name: 'IET' },
  { code: 'IST', name: 'IST' },
  { code: 'Iceland', name: 'Iceland' },
  { code: 'Indian/Antananarivo', name: 'Indian/Antananarivo' },
  { code: 'Indian/Chagos', name: 'Indian/Chagos' },
  { code: 'Indian/Christmas', name: 'Indian/Christmas' },
  { code: 'Indian/Cocos', name: 'Indian/Cocos' },
  { code: 'Indian/Comoro', name: 'Indian/Comoro' },
  { code: 'Indian/Kerguelen', name: 'Indian/Kerguelen' },
  { code: 'Indian/Mahe', name: 'Indian/Mahe' },
  { code: 'Indian/Maldives', name: 'Indian/Maldives' },
  { code: 'Indian/Mauritius', name: 'Indian/Mauritius' },
  { code: 'Indian/Mayotte', name: 'Indian/Mayotte' },
  { code: 'Indian/Reunion', name: 'Indian/Reunion' },
  { code: 'Iran', name: 'Iran' },
  { code: 'Israel', name: 'Israel' },
  { code: 'JST', name: 'JST' },
  { code: 'Jamaica', name: 'Jamaica' },
  { code: 'Japan', name: 'Japan' },
  { code: 'Kwajalein', name: 'Kwajalein' },
  { code: 'Libya', name: 'Libya' },
  { code: 'MET', name: 'MET' },
  { code: 'MIT', name: 'MIT' },
  { code: 'MST', name: 'MST' },
  { code: 'MST7MDT', name: 'MST7MDT' },
  { code: 'Mexico/BajaNorte', name: 'Mexico/BajaNorte' },
  { code: 'Mexico/BajaSur', name: 'Mexico/BajaSur' },
  { code: 'Mexico/General', name: 'Mexico/General' },
  { code: 'Mideast/Riyadh87', name: 'Mideast/Riyadh87' },
  { code: 'Mideast/Riyadh88', name: 'Mideast/Riyadh88' },
  { code: 'Mideast/Riyadh89', name: 'Mideast/Riyadh89' },
  { code: 'NET', name: 'NET' },
  { code: 'NST', name: 'NST' },
  { code: 'NZ', name: 'NZ' },
  { code: 'NZ-CHAT', name: 'NZ-CHAT' },
  { code: 'Navajo', name: 'Navajo' },
  { code: 'PLT', name: 'PLT' },
  { code: 'PNT', name: 'PNT' },
  { code: 'PRC', name: 'PRC' },
  { code: 'PRT', name: 'PRT' },
  { code: 'PST', name: 'PST' },
  { code: 'PST8PDT', name: 'PST8PDT' },
  { code: 'Pacific/Apia', name: 'Pacific/Apia' },
  { code: 'Pacific/Auckland', name: 'Pacific/Auckland' },
  { code: 'Pacific/Bougainville', name: 'Pacific/Bougainville' },
  { code: 'Pacific/Chatham', name: 'Pacific/Chatham' },
  { code: 'Pacific/Chuuk', name: 'Pacific/Chuuk' },
  { code: 'Pacific/Easter', name: 'Pacific/Easter' },
  { code: 'Pacific/Efate', name: 'Pacific/Efate' },
  { code: 'Pacific/Enderbury', name: 'Pacific/Enderbury' },
  { code: 'Pacific/Fakaofo', name: 'Pacific/Fakaofo' },
  { code: 'Pacific/Fiji', name: 'Pacific/Fiji' },
  { code: 'Pacific/Funafuti', name: 'Pacific/Funafuti' },
  { code: 'Pacific/Galapagos', name: 'Pacific/Galapagos' },
  { code: 'Pacific/Gambier', name: 'Pacific/Gambier' },
  { code: 'Pacific/Guadalcanal', name: 'Pacific/Guadalcanal' },
  { code: 'Pacific/Guam', name: 'Pacific/Guam' },
  { code: 'Pacific/Honolulu', name: 'Pacific/Honolulu' },
  { code: 'Pacific/Johnston', name: 'Pacific/Johnston' },
  { code: 'Pacific/Kiritimati', name: 'Pacific/Kiritimati' },
  { code: 'Pacific/Kosrae', name: 'Pacific/Kosrae' },
  { code: 'Pacific/Kwajalein', name: 'Pacific/Kwajalein' },
  { code: 'Pacific/Majuro', name: 'Pacific/Majuro' },
  { code: 'Pacific/Marquesas', name: 'Pacific/Marquesas' },
  { code: 'Pacific/Midway', name: 'Pacific/Midway' },
  { code: 'Pacific/Nauru', name: 'Pacific/Nauru' },
  { code: 'Pacific/Niue', name: 'Pacific/Niue' },
  { code: 'Pacific/Norfolk', name: 'Pacific/Norfolk' },
  { code: 'Pacific/Noumea', name: 'Pacific/Noumea' },
  { code: 'Pacific/Pago_Pago', name: 'Pacific/Pago_Pago' },
  { code: 'Pacific/Palau', name: 'Pacific/Palau' },
  { code: 'Pacific/Pitcairn', name: 'Pacific/Pitcairn' },
  { code: 'Pacific/Pohnpei', name: 'Pacific/Pohnpei' },
  { code: 'Pacific/Ponape', name: 'Pacific/Ponape' },
  { code: 'Pacific/Port_Moresby', name: 'Pacific/Port_Moresby' },
  { code: 'Pacific/Rarotonga', name: 'Pacific/Rarotonga' },
  { code: 'Pacific/Saipan', name: 'Pacific/Saipan' },
  { code: 'Pacific/Samoa', name: 'Pacific/Samoa' },
  { code: 'Pacific/Tahiti', name: 'Pacific/Tahiti' },
  { code: 'Pacific/Tarawa', name: 'Pacific/Tarawa' },
  { code: 'Pacific/Tongatapu', name: 'Pacific/Tongatapu' },
  { code: 'Pacific/Truk', name: 'Pacific/Truk' },
  { code: 'Pacific/Wake', name: 'Pacific/Wake' },
  { code: 'Pacific/Wallis', name: 'Pacific/Wallis' },
  { code: 'Pacific/Yap', name: 'Pacific/Yap' },
  { code: 'Poland', name: 'Poland' },
  { code: 'Portugal', name: 'Portugal' },
  { code: 'ROK', name: 'ROK' },
  { code: 'SST', name: 'SST' },
  { code: 'Singapore', name: 'Singapore' },
  { code: 'Turkey', name: 'Turkey' },
  { code: 'UCT', name: 'UCT' },
  { code: 'US/Alaska', name: 'US/Alaska' },
  { code: 'US/Aleutian', name: 'US/Aleutian' },
  { code: 'US/Arizona', name: 'US/Arizona' },
  { code: 'US/Central', name: 'US/Central' },
  { code: 'US/East-Indiana', name: 'US/East-Indiana' },
  { code: 'US/Eastern', name: 'US/Eastern' },
  { code: 'US/Hawaii', name: 'US/Hawaii' },
  { code: 'US/Indiana-Starke', name: 'US/Indiana-Starke' },
  { code: 'US/Michigan', name: 'US/Michigan' },
  { code: 'US/Mountain', name: 'US/Mountain' },
  { code: 'US/Pacific', name: 'US/Pacific' },
  { code: 'US/Pacific-New', name: 'US/Pacific-New' },
  { code: 'US/Samoa', name: 'US/Samoa' },
  { code: 'UTC', name: 'UTC' },
  { code: 'Universal', name: 'Universal' },
  { code: 'VST', name: 'VST' },
  { code: 'W-SU', name: 'W-SU' },
  { code: 'WET', name: 'WET' },
  { code: 'Zulu', name: 'Zulu' },
];
